import { render } from "./BetslipModal.vue?vue&type=template&id=2e12c4ea&scoped=true"
import script from "./BetslipModal.vue?vue&type=script&lang=js"
export * from "./BetslipModal.vue?vue&type=script&lang=js"

import "./BetslipModal.vue?vue&type=style&index=0&id=2e12c4ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e12c4ea"]])

export default __exports__